/**
 * 设置page属性hook
 */

import { useEffect, useRef } from 'react';
import useDidMount from '../useDidMount';
import useBackground from './useBackground';
import useTitle from './useTitle';
import useWxConfig, { wxSdkSign } from './useWxConfig';

interface PageConfig {
  title?: string;
  shareConfig?: any;
  wxJSApiList?: any;
  backgroundColor?: string;
  wxHideMenuItems?: Partial<any[]>;
  errorHandler?: (e: any) => void;
}

export default (config: string | PageConfig) => {
  let title = '';
  let shareConfig: PageConfig['shareConfig'] = undefined;
  let backgroundColor: PageConfig['backgroundColor'] = '';
  let wxJSApiList: any = [];
  let wxHideMenuItems: any = [];
  let errorHandler: (e: any) => void = () => {};

  if (typeof config === 'string') {
    title = config;
  } else {
    title = config.title || '';
    shareConfig = config.shareConfig;
    backgroundColor = config.backgroundColor || '';
    wxJSApiList = config.wxJSApiList || [];
    wxHideMenuItems = config.wxHideMenuItems || [];
    errorHandler = config.errorHandler || (() => {});
  }

  useTitle(title);
  useBackground(backgroundColor);
  const wxConfig = useWxConfig(wxJSApiList, wxHideMenuItems, errorHandler);

  useEffect(() => {
    wxConfig.share({ title: title || '医联分享', ...shareConfig });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  useDidMount(() => {
    wxSdkSign();
  });

  return useRef({ wxConfig }).current;
};
